import ContractsTable from "@/components/financiacion/ContractsTable";

const Leasings = () => <ContractsTable kind="leasing" />;

export default Leasings;
